import React from 'react';
import '../less/index.less';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import hero_img from '../img/hero_img.png';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import TextBlock from '../../../../../auxiliary-components/shared/TextBlock';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import tariffsData from '../enums/how_to_data.json';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'credit-debt';

    const tabs = [{tab: 'conditions', title: 'CREDIT_DEBT_TABS_TITLE_01'},
      {tab: 'how-to', title: 'CREDIT_DEBT_TABS_TITLE_02'}];
      
    const hero_data = {
      title: 'CREDIT_DEBT_HERO_TITLE',
      text: 'CREDIT_DEBT_HERO_TEXT',
      link: {
        text: "CREDIT_DEBT_HERO_BTN",
        onClick: () => window.open('/services/abank', '_self'),
      }
    };

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="credit-debt">
        <Hero
          data={hero_data}
          img={hero_img}
          page={page}
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <div>
                <TitleBlock title={'CREDIT_DEBT_TITLE_01'}/>
                <TextBlock text={'CREDIT_DEBT_TEXT_01'} maxWidth="924px"/>
                <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
                  <Tariffs widget={this.widgetsHelper.getWidget.call(this, 'information_table')}/>
                  <Tariffs items={tariffsData}/>
                </Tabs>
                <TextBlock text={'CREDIT_DEBT_TEXT_02'} className="credit-debt-text-2"/>
                <TitleBlock title={'CREDIT_DEBT_TITLE_02'}/>
                <TextBlock text={'CREDIT_DEBT_TEXT_03'} className="credit-debt-text-3"/>
              </div>
              <QuestionsAdminNew
                title={this.l10n('CREDIT_DEBT_FAQ_STORYBOOK_TITLE')}
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                page={page}
              />
              <FilesForDownloadNew
                widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              />
              <TextAboveFooterNew
                widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('CREDIT_DEBT_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('CREDIT_DEBT_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
      </div>
    );
}